import { useReadContract } from 'wagmi'
import { getChainId } from 'wagmi/actions'

import { config } from '@/config/wagmi'
import { useValueTokens } from '@/contexts/VaultTokensContext'
import seaAVAX from '@/contracts/seaAVAX'
import xGGP from '@/contracts/xGGP'

export const useVaultTotalAssets = () => {
  const { currentToken } = useValueTokens()
  const chainId = getChainId(config)
  const addr = currentToken.tokenAddresses[1][chainId]

  const { data, error } = useReadContract({
    address: addr as `0x${string}`,
    abi: currentToken.displayName === 'GGP' ? xGGP : seaAVAX,
    functionName: 'totalAssets',
  })

  if (error) {
    console.error('Error reading totalAssets:', error)
  }

  return { data }
}

export const useVaultCap = () => {
  const { currentToken } = useValueTokens()
  const chainId = getChainId(config)
  const addr = currentToken.tokenAddresses[1][chainId]

  const { data, error } = useReadContract({
    address: addr as `0x${string}`,
    abi: currentToken.displayName === 'GGP' ? xGGP : seaAVAX,
    functionName: currentToken.displayName === 'GGP' ? 'GGPCap' : 'AVAXCap',
  })

  if (error) {
    console.error('Error reading Cap:', error)
  }

  return { data }
}

export const usePendingRewards = () => {
  const { currentToken } = useValueTokens()
  const chainId = getChainId(config)
  const addr = currentToken.tokenAddresses[1][chainId]

  const { data, error } = useReadContract({
    query: { refetchInterval: 1000 },
    address: addr as `0x${string}`,
    abi: seaAVAX,
    functionName: 'getPendingRewards',
  })

  if (error) {
    console.error('Error reading getPendingRewards:', error)
  }

  return { data }
}

export const useVaultRatio = () => {
  const { currentToken } = useValueTokens()
  const chainId = getChainId(config)
  const addr = currentToken.tokenAddresses[1][chainId]

  const { data, error } = useReadContract({
    address: addr as `0x${string}`,
    abi: currentToken.displayName === 'GGP' ? xGGP : seaAVAX,
    functionName: 'convertToAssets',
    args: [1000000000000000000n],
  })

  if (error) {
    console.error('Error reading convertToAssets:', error)
  }

  return { data }
}

export const useAPYinBasis = () => {
  const { currentToken } = useValueTokens()
  const chainId = getChainId(config)
  const addr = currentToken.tokenAddresses[1][chainId]

  const { data, error } = useReadContract({
    address: addr as `0x${string}`,
    abi: currentToken.displayName === 'GGP' ? xGGP : seaAVAX,
    functionName: 'calculateAPYFromAPR',
  })

  if (error) {
    console.error('Error reading calculateAPYFromAPR:', error)
  }

  return { data }
}

export const useUnderlyingBalance = () => {
  const { currentToken } = useValueTokens()
  const chainId = getChainId(config)
  const addr = currentToken.tokenAddresses[1][chainId]

  const { data, error } = useReadContract({
    address: addr as `0x${string}`,
    abi: xGGP,
    functionName: 'getUnderlyingBalance',
    query: { refetchInterval: 5000 },
  })

  if (error) {
    console.error('Error reading getUnderlyingBalance:', error)
  }

  return { data }
}
